import { FC } from 'react';
import Home from './Home';
import UseHome from './UseHome';

const HomeContainer: FC = () => {
  return <Home {...UseHome()} />;
};

export default HomeContainer;
